import React, { FunctionComponent } from 'react';

import chat_ic from '../../../images/chat_create_new_inv.svg';

import { FOHImage } from '../../ingredients';
import { FOHIconProps } from '../../typings';

export const FOHChatCreateNewInvertedIcon: FunctionComponent<FOHIconProps> = ({
  style
}) => (
  <FOHImage
    source={{ uri: chat_ic }}
    style={[{ width: 32, height: 32 }, style]}
  />
);
